<template lang="html">

  <VqModal
    :name="modalName"
    class="vq-modal-delete-vm">
    <template v-slot:header>
      <h2 class="modal-title">{{setTitleContext($t('components.modalDeletePool.del'))}} <span class="is-bold">{{ $t('components.modalDeletePool.pool') }}</span></h2>
      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>
    <template v-slot:content>
  <div class="forms">
    <form>
      <div class="container has-separator">
        <div class="row">
          <div>
            <p class="pb-5">
              {{ $t('components.modalDeletePool.title') }} "
              <span class="is-bold">{{poolName}}</span>"
            </p>
            <p class="is-thin">{{ $t('components.modalDeletePool.content') }}</p>
          </div>
        </div>
      </div>
      <div class="container has-separator">
        <div class="row">
          <div>
            <p class="pb-5">{{ $t('components.modalDeletePool.title2') }}</p>
            <p class="is-thin">{{ $t('components.modalDeletePool.content2') }}</p>
            <VqRadio
              :options="radioOptions"
              :default="radioDefault"
              name="deletePool"
              :model.sync="radioData"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
    <template v-slot:footer>
  <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalDeletePool.cancel') }}</button>
  <button
    type="button"
    class="button is-small is-danger is-outline"
    @click="submit"
  >{{ $t('components.modalDeletePool.delete') }}</button>
</template>
  </VqModal>

</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';

import SUPPORT from '@/api/support';

import VqModal from '@/components/VqModal.vue';
import VqRadio from '@/components/VqRadio.vue';


export default {
  name: 'ModalDeletePool',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqRadio,
  },

  data() {
    return {
      modalName: 'delete-pool',
      context: 'delete',
      poolName: '',
      radioOptions: [
        {
          label: 'Yes',
          value: true,
        },
        {
          label: 'No',
          value: false,
        },
      ],
      radioDefault: 'No',
      radioData: { value: false },
      price: 0,
      deleteModalData: {
        pool_name: '',
        certificate: '',
        price: 0,
      },
    };
  },
  mounted() {
    this.eventHub.$on(`modal:${this.modalName}:open`, (data) => {
      this.poolName = data.name;
      this.price = data.price;
    });
  },
  methods: {
    submit() {
      this.deleteModalData.pool_name = this.poolName;
      this.deleteModalData.certificate = this.radioData.value;
      this.deleteModalData.price = this.price;
      SUPPORT.deletePool(this.deleteModalData).then(
        (res) => {
          this.close();
          this.emitToaster(res.data);
        },
        (err) => {
          Object.assign(this.errors, err.response.data);
        },
      );
    },
    close() {
      this.eventHub.$emit(`modal:${this.modalName}:close`);
    },
    setTitleContext(title) {
      return title.charAt(0).toUpperCase() + title.slice(1);
    },

    emitToaster(data) {
      this.emitAddToaster({
        title: this.$t('components.modalDeletePool.toasts.title'),
        text: this.$t('components.modalDeletePool.toasts.content'),
        state: 'info',
        // 'link': 'http://telecloud.fr'
      });
    },
  },
  computed: {

  },
};
</script>
